import React, { useState } from 'react';
import { FormContainer, useForm } from 'react-hook-form-mui';

import { ToolsModalStepsEnum } from 'core/enums';
import { translate } from 'utils';

import { ModalHeader } from 'components/_commons/Modals/_ModalHeader';
import { ModalProps } from 'hooks/ModalProvider';
import { AddToolModalActions } from './AddToolModalActions';
import { ToolFormContainer } from './ToolFormContainer';

export const AddToolsModal = ({
  modalState: {
    equipment, equipmentType, requestId
  },
  onSubmit, onClose
}: ModalProps<any>) => {
  const [currentStep, setCurrentStep] = useState(ToolsModalStepsEnum.Registration);
  const [isToolSaving, setIsToolSaving] = useState(false);

  const formContext = useForm({
    defaultValues: {
      ...equipment,
      equipmentView: {
        ...equipment?.equipmentView,
        documentList: {
          ...equipment?.equipmentView?.documentList,
          innerDocuments: equipment?.equipmentView?.documentList?.documents?.reduce((prev, curr) => ({
            ...prev,
            [curr.type?.name]: (prev[curr.type?.name]) ? [...prev[curr.type?.name], curr] : [curr]
          }), {})
        },
        type: equipmentType
      }
    }
  });

  const onGoBack = () => {
    setCurrentStep(ToolsModalStepsEnum.prevStep(currentStep));
  };
  const onSubmitForm = (values) => {
    if ([ToolsModalStepsEnum.Registration, ToolsModalStepsEnum.Summary].includes(currentStep)) {
      onSubmit(values, setIsToolSaving);
    } else {
      setCurrentStep(ToolsModalStepsEnum.nextStep(currentStep));
    }
  };

  const handleNextStep = () => {
    formContext.handleSubmit(() => setCurrentStep(ToolsModalStepsEnum.nextStep(currentStep)))();
  };

  return (
    <FormContainer
      formContext={formContext}
      FormProps={{ autoComplete: 'off', name: 'addToolsForm', style: { overflow: 'auto' } }}
      onSuccess={onSubmitForm}
    >
      <ModalHeader onClose={onClose}>
        {`${equipmentType.label} - ${translate(equipment?.id
          ? 'attestationFormRequest.tools.modal.title.edit'
          : 'attestationFormRequest.tools.modal.title.add')}`}
      </ModalHeader>
      <ToolFormContainer
        currentStep={currentStep}
        equipment={equipment}
        equipmentType={equipmentType}
        formContext={formContext}
        requestId={requestId}
      />
      <AddToolModalActions
        currentStep={currentStep}
        disabled={false}
        goBack={onGoBack}
        isSaving={isToolSaving}
        onClose={onClose}
        onNextStep={handleNextStep}
      />
    </FormContainer>
  );
};
